import React from 'react';
import {EdgeProps} from 'reactflow';

import BaseEdgeRenderer from 'ui-library/reactflow/edges/BaseEdgeRenderer';
import {ReactFlowLockedContext} from 'ui-library/reactflow/LockedContext';

import {getEdgeStatus} from './edgeUtils';
import RemoveEdgeLabel from './RemoveEdgeLabel';

export default function TaskSchemaControlFlowEdge(props: EdgeProps): JSX.Element {
  const locked = ReactFlowLockedContext.useContext() ?? false;

  return (
    <>
      <BaseEdgeRenderer {...props} data={{...props.data, status: getEdgeStatus(props)}} />
      {props.selected && !locked && <RemoveEdgeLabel {...props} />}
    </>
  );
}
